import { BreadcrumbComponentModule } from "./../_component/breadcrumb/breadcrumb.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { UsersPageRoutingModule } from "./users-routing.module";

import { UsersPage } from "./users.page";
import { TranslateModule } from "@ngx-translate/core";
import { PaginationClientSideModule } from "../_component/pagination-client-side/pagination-client-side.module";
import { UserViewModule } from "./user-view/user-view.module";
import { HeaderModule } from "../../_component/header/header.module";
import { SharedDirectivesModule } from "../../_directives/shared-directives.module";
import { SearchBarModule } from "../_component/search-bar/search-bar.module";
import { LoadingStiModule } from "../../_component/loading-sti/loading-sti.module";
import { ListHeaderComponentModule } from "../_component/_structural/list-header/list-header.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    UsersPageRoutingModule,
    PaginationClientSideModule,
    UserViewModule,
    HeaderModule,
    SharedDirectivesModule,
    SearchBarModule,
    LoadingStiModule,
    BreadcrumbComponentModule,
    ListHeaderComponentModule,
  ],
  declarations: [UsersPage],
})
export class UsersPageModule {}
